import React, { type ReactNode } from "react";
import { createClasses } from "@bloomberg/media-ui-core";

import styles from "./gridLayout.module.css";

type GridLayoutProps = {
    children: ReactNode;
    className?: string;
};

export const GridLayout = ({ children, className }: GridLayoutProps) => {
    const cx = createClasses([styles.gridLayout, className]);

    return <div className={cx}>{children}</div>;
};
